import { useConfigSlice } from '@pp/core/src/store/slices/config/selectors';
import { useGameStateSlice } from '@pp/core/src/store/slices/game/selectors';

import { HIGHFLYER_PT } from '../../../config';
import { getKeepAliveSender } from '../../../controllers/gameCommunication/config';

export const useCommunicationKeepAlive = (): void => {
  const isGamePaused = useGameStateSlice.getIsGamePaused();
  const tableVariant = useConfigSlice.getTableVariant();
  const isHighflyerPT = tableVariant === HIGHFLYER_PT;
  const sender = getKeepAliveSender();
  sender.refreshSchedulerState(isGamePaused, isHighflyerPT);
};
